import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowLeft, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { trackAndOpenWhatsApp } from '../data/mockData';

export const ThankYou = () => {
  useEffect(() => {
    document.title = 'Obrigado! · Plantinha de Geladeira';
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-11077389987/cPCkCKfg36AcEKOdjqIp' });
    }
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-rose-50 px-6 py-20">
      <div className="max-w-2xl w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#20BA5A] to-[#178C41] flex items-center justify-center shadow-xl">
          <Check className="h-10 w-10 text-white" strokeWidth={3} />
        </div>

        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">
          Recebemos seu pedido! <span className="inline-block">🌱</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed">
          Em até <strong className="text-[#eb068c]">24 horas</strong> nossa equipe entra em contato
          com uma proposta personalizada pra sua empresa.
        </p>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-pink-100 mb-8">
          <p className="text-gray-700 mb-4">
            Quer adiantar o atendimento? Fale com a gente agora pelo WhatsApp:
          </p>
          <Button
            size="lg"
            data-testid="thankyou-whatsapp"
            onClick={trackAndOpenWhatsApp}
            className="bg-[#20BA5A] hover:bg-[#178C41] text-white px-8 py-6 text-base md:text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            Falar agora no WhatsApp
          </Button>
        </div>

        <Link
          to="/"
          data-testid="thankyou-home"
          className="inline-flex items-center gap-2 text-gray-600 hover:text-[#eb068c] font-medium transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Voltar para a home
        </Link>
      </div>
    </section>
  );
};
